import React, {useState, useEffect} from 'react'
import {connect} from 'react-redux'
import { Card, Layout, Col, Row, message, Popconfirm, Modal, Button, Form, Input, InputNumber, Select } from 'antd'
import axios from 'axios'
import { CloseCircleOutlined, PlusCircleFilled } from '@ant-design/icons'
import {logoff} from '../store/actions/auth'

const { Meta } = Card
const { Header, Content, Footer, Sider } = Layout;
function Noticias(props) {

    var [noticias, setNoticias] = useState([])
    const [isModalVisible, setIsModalVisible] = useState(false)
    const [form] = Form.useForm()
    var [title, setTitle] = useState("Título")
    var [link, setLink] = useState("local")
    var [days, setDays] = useState(10)
    var [time, setTime] = useState(10)
    const [selectedImg, setSelectedImg] = useState()
    const [contentType, setContentType] = useState('image')
    


    const showModal = () => {
        setIsModalVisible(true);
    }

    const handleOk = () => {
        const formData = new FormData()

		formData.append('imagem', selectedImg)
        formData.set('time', time)
        formData.set('days', days)
        formData.set('title', title)
        formData.set('link', link)
        formData.set('type', contentType)

		fetch(
			props.API_HOST + '/',
			{
				method: 'POST',
				body: formData,
                headers: {"Authorization": "Bearer "+props.keycloak.token}
			}
		)
			.then((result) => {
				console.log('Success:', result)
                message.success('Notícia inserida')
                setIsModalVisible(false)
                form.resetFields()
                setTitle("Título")
                setLink("local")
                setDays(10)
                setTime(10)
                setSelectedImg(null)
                setContentType('image')
                loadData()
			})
			.catch((error) => {
				console.error('Error:', error)
                message.error('Erro:' + error)
			});
    }

    const handleCancel = () => {
        setIsModalVisible(false);
        form.resetFields();
        setContentType('image')
    }

    const loadData = () => {
        const config = {headers: {"Authorization": "Bearer "+props.keycloak.token}}
        axios.get(props.API_HOST+'/', config).then(response => {
            
            var nos = []
            response.data.forEach(no => {
                nos.push(
                    <Col sm={24} md={8} xl={6} style={{padding: 10}} >
                        <a href={no.link} target={'_blank'}>
                            <Card hoverable style={{ width: 240 }} cover={<img alt="example" src={props.API_HOST + "/images/" + no._id} />}
                                actions={[
                                    <Popconfirm title="Você confirma essa remoção？" okText="Sim" cancelText="Não" onConfirm={() => deletar(no._id)}>
                                        <CloseCircleOutlined key="remover" />
                                    </Popconfirm>
                                    
                                ]} color='red' >
                                <Meta title={no.title} description={no.link}  />
                            </Card>
                        </a>
                    </Col>
                )
            })
            setNoticias(nos)

        }).catch(error => console.log(error))
    }

    const deletar = (id)  => {

        console.log("Deletando " + id)
        const config = {headers: {"Authorization": "Bearer "+props.keycloak.token}}
        axios.delete(props.API_HOST+'/'+id, config).then(response => {
            console.log("removido com sucesso")
            message.success("removido com sucesso");
            loadData()
        })
        .catch( (err) => {
            message.error("Não foi possível remover:" + err)
            console.log("Não foi possível remover:" + err)
        })

    }

    const onFinish = (noticia) => {
      console.log('noticia:', noticia)

    }
    
    const onFinishFailed = (errorInfo) => {
      console.log('Failed:', errorInfo)
    }
    const changeImg = (event) => {
		setSelectedImg(event.target.files[0])
	}

    useEffect( ()=> {
        loadData()
    }, [])

    return (
    <>
        <Layout>
            
            <Layout>
            <Header className="site-layout-sub-header-background" style={{ padding: 0,}}>
                <div style={{marginRight: '20px', textAlign: 'right'}} >
                    <Button shape='round' onClick={() => props.logoffUser(props.keycloak)} danger>
                        Sair
                    </Button>
                </div>
            </Header>
            <Content style={{ margin: '24px 16px 0'}}>
                <div className="site-layout-background" style={{ padding: 24, minHeight: 360,}}>
                    <Row>
                        <Col sm={24} style={{textAlign: 'right', paddingBottom: '20px', paddingRight: '50px'}}>
                            <Button shape='round' type="primary" onClick={showModal} icon={<PlusCircleFilled />}>
                                Adicionar
                            </Button>
                            <Modal title="Adicionar Notícia" open={isModalVisible} onCancel={handleCancel} onOk={handleOk}>
                                <Form
                                    form={form}
                                    layout="vertical"
                                    autoComplete="off"
                                >
                                    <Form.Item
                                        label="Título"
                                        name="title"
                                        initialValue={title}
                                    >
                                        <Input onChange={(e) => setTitle(e.target.value)} />
                                    </Form.Item>

                                    <Form.Item
                                        label="Link ou local"
                                        name="link"
                                        initialValue={link}
                                    >
                                        <Input onChange={(e) => setLink(e.target.value)} />
                                    </Form.Item>

                                    <Form.Item
                                        label="Dias em Exibição"
                                        name="days"
                                        initialValue={days}
                                    >
                                        <InputNumber min={1} max={60} onChange={setDays} style={{width: '100%'}} />
                                    </Form.Item>

                                    <Form.Item
                                        label="Tempo (em segundos)"
                                        name="time"
                                        initialValue={time}
                                    >
                                        <InputNumber min={5} max={120} onChange={setTime} style={{width: '100%'}} />
                                    </Form.Item>

                                    

                                    <Form.Item
                                        label="Tipo do conteúdo"
                                        name="type"
                                        initialValue="image"
                                    >
                                        <Select onChange={setContentType}>
                                            <Select.Option value="image">Imagem</Select.Option>
                                            <Select.Option value="video">Vídeo</Select.Option>
                                        </Select>
                                    </Form.Item>

                                    <Form.Item
                                        label="Imagem"
                                        name="imagem"
                                    >
                                        <input type="file" onChange={changeImg} />
                                    </Form.Item>
                                </Form>
                            </Modal>
                        </Col>
                    </Row>
                    <Row>
                        {noticias}
                    </Row>
                </div>
            </Content>
            <Footer style={{ textAlign: 'center'}}>
                CGTI IFRO Ariquemes
            </Footer>
            </Layout>
        </Layout>
    </>
    )
}

function mapStateToProps(state) {

    return {
        keycloak: state.auth.keycloak,
        userInfo: state.auth.userInfo,
        authenticated: state.auth.authenticated,
        API_HOST: state.config.API_HOST
    }
  
  }
function mapActionCreatorsToProp(dispatch) {
    return {
        logoffUser(keycloak) {
            keycloak.logout()
            console.log("Fazendo logoff")
            const action = logoff()
            dispatch(action)
        }
    }
}
  

  
  export default connect(mapStateToProps, mapActionCreatorsToProp)(Noticias)